$(document).ready(function () {
  var $slider = $('.slick-cb-filters');

  function initSlickIfNeeded() {
    // reset (in case of resize)
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    var containerWidth = $slider.outerWidth();
    var slidesWidth = 0;
    
    $slider.children().each(function () {
      slidesWidth += $(this).outerWidth(true); // include margin
    });

    // If total slides width > container width, initialize slick
    if (slidesWidth >= containerWidth) {
      $slider.slick({
        slidesToShow: 7,   // or your default
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1550,
                settings: { slidesToShow: 6 }
            },
            {
                breakpoint: 1379,
                settings: { slidesToShow: 5 }
            },
            {
                breakpoint: 1101,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 799,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1.5 }
            }
        ]
      });
    }
  }

  // Run on load
  initSlickIfNeeded();

  // Run on window resize
  $(window).on('resize', function () {
    initSlickIfNeeded();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll("[data-menu-title]");
  const blocks = document.querySelectorAll("[data-image-title]");
  let lastActive = null;

  function hideAllBlocks() {
    blocks.forEach(block => block.classList.remove("active"));
  }

  // 🔹 Don't activate anything by default
  // lastActive = null;

  // Hover logic (data-menu-title ↔ data-image-title)
  menuItems.forEach(menuItem => {
    menuItem.addEventListener("mouseenter", () => {
      const target = menuItem.getAttribute("data-menu-title");
      const targetBlock = document.querySelector(`[data-image-title="${target}"]`);

      if (targetBlock) {
        hideAllBlocks();
        targetBlock.classList.add("active");
        lastActive = targetBlock;
      }

      // Hide parent wrapper while hovering
      document.querySelectorAll("[data-maintitle]").forEach(parent => {
        const parentWrapper = parent.closest(".has--stepnav[data-maintitle]");
        if (parentWrapper) parentWrapper.classList.add("hide");
      });
    });
  });

  // Main menu hover remove and inner menu reset
  document.querySelectorAll("[data-maintitle]").forEach(parent => {
    parent.addEventListener("mouseleave", () => {
      document
        .querySelectorAll(".has--stepnav[data-maintitle]")
        .forEach(parentWrap => parentWrap.classList.remove("hide"));

      const tier = parent.nextElementSibling;
      if (!tier) return;

      const firstChild = tier.querySelector("[data-menu-title]");
      if (!firstChild) return;

      // Reset to no active when leaving parent
      hideAllBlocks();
      lastActive = null;
    });
  });

  // Reset when leaving the whole menu wrapper
  const megaMenu = document.querySelector(".navigation__item");
  if (megaMenu) {
    megaMenu.addEventListener("mouseleave", () => {
      hideAllBlocks();
      lastActive = null; // no default active
    });
  }
});


